import { Avatar } from "@tokenterminal/core/ui/icon/Avatar"
import { Card } from "@tokenterminal/core/ui/layout/card/Card"
import Image from "next/image"
import { twMerge } from "tailwind-merge"

interface BlockquoteProps {
  content: React.ReactNode
  author: string
  authorTitle: string
  authorImage: string
  className?: string
}

export default function NicerBlockquote({
  content,
  author,
  authorTitle,
  authorImage,
  className,
}: BlockquoteProps) {
  return (
    <Card className={twMerge("flex flex-col gap-6 my-10 rounded-2xl", className)}>
      <p className="my-0 text-base lg:text-2xl text-fg-default text-pretty">
        &quot;{content}&quot;
      </p>
      <div className="flex items-center gap-3 max-h-[100px]">
        {authorImage ? (
          <Image
            src={authorImage}
            alt={author}
            height={32}
            width={32}
            className="rounded-full my-0"
          />
        ) : (
          <Avatar size="small"></Avatar>
        )}
        <div className="flex flex-col">
          <p className="text-sm font-medium my-0">{author}</p>
          <p className="text-xs my-0 text-fg-secondary">{authorTitle}</p>
        </div>
      </div>
    </Card>
  )
}
